import * as yup from 'yup';
export const samApiToken = {
    token: 'Basic eyJVc2VybmFtZSI6ImdnaC5TQU0iLCJQYXNzd29yZCI6IkdHSEBnZ2gxMjMifQ==',
    apiKey: '5A7B6C8D-9E0F-4A1B-2C3D-4E5F6G7H8I9J'
};

export const generateAssmtToken = {
    token: 'Basic eyJVc2VybmFtZSI6ImdnaC5hZG1pbiIsIlBhc3N3b3JkIjoiR0dIQHNzaDEyMyJ9',
    apiKey: 'B080DFFD-B4A8-432D-B4EE-94933CC6AEC4'
};

export const needValidationSchema = yup.object({
    category: yup.object().required('required'),
    subCategory: yup.array().required('required').min(1)
});

export const goalvalidationSchema = yup.object({
    goal: yup.string().required('required')
});

export const generateAssmtValidationSchema = yup.object({
    assessment: yup.object().required('required')
});

export const untagSchema = yup.object({
    reason: yup.object().required('required')
});

export const typeOfNeeds = {
    auto: 1,
    untag: 4,
    custom: 2
};

export const prepareListOfTree = (listOfGoal) => {
    let newArr = [];
    listOfGoal?.forEach((item, iKey) => {
        if (item?.goals?.length) {
            item?.goals?.forEach((gl, gKey) => {
                newArr.push({
                    category: item?.needCategory || item?.needCategoryIcd10Id,
                    categoryId: item?.needCategoryIcd10Id,
                    subCategory: item?.needSubCategory,
                    subCategoryId: item?.needSubCategoryIcd10Id,
                    needType: item?.needType,
                    goal: gl,
                    goalId: iKey + '' + gKey
                });
            });
        } else {
            newArr.push({
                category: item?.needCategory || item?.needCategoryIcd10Id,
                categoryId: item?.needCategoryIcd10Id,
                subCategory: item?.needSubCategory,
                subCategoryId: item?.needSubCategoryIcd10Id,
                needType: item?.needType,
                goal: ''
            });
        }
    });

    // return [...newArr];
    const groupedByCategory = newArr?.reduce((result, item) => {
        const category = item.category;
        if (!result[category]) {
            result[category] = [];
        }
        result[category].push(item);
        return result;
    }, {});

    const arrayOfGroupedCategories = Object.values(groupedByCategory)?.flat();
    return [...arrayOfGroupedCategories];
};

export const prepareTreeList = (listOfGoal, boolValue) => {
    let newArr = [];
    if (boolValue) {
        listOfGoal?.forEach((item, iKey) => {
            if (item?.goals?.length) {
                item?.goals?.forEach((gl, gKey) => {
                    newArr.push({
                        category: item?.needCategory || item?.needCategoryIcd10Id,
                        categoryId: item?.needCategoryIcd10Id,
                        subCategory: item?.needSubCategory,
                        subCategoryId: item?.needSubCategoryIcd10Id,
                        needType: item?.needType,
                        goal: gl,
                        goalId: iKey + '' + gKey
                    });
                });
            } else {
                newArr.push({
                    category: item?.needCategory || item?.needCategoryIcd10Id,
                    categoryId: item?.needCategoryIcd10Id,
                    subCategory: item?.needSubCategory,
                    subCategoryId: item?.needSubCategoryIcd10Id,
                    needType: item?.needType,
                    goal: ''
                });
            }
        });
    } else if (!boolValue) {
        listOfGoal?.forEach((item) => {
            newArr.push({
                needCategoryIcd10Id: item?.needCategoryIcd10Id,
                needSubCategoryIcd10Id: item?.needSubCategoryIcd10Id,
                goals: item?.goals?.map((e) => e),
                needType: item?.needType
            });
        });
    }
    const groupedByCategory = newArr?.reduce((result, item) => {
        const category = item.category;
        if (!result[category]) {
            result[category] = [];
        }
        result[category].push(item);
        return result;
    }, {});

    const arrayOfGroupedCategories = Object.values(groupedByCategory)?.flat();
    return arrayOfGroupedCategories;
};

export const needPayLoadWithRaw = (listOfRow, uniqueLink) => {
    let reqBody = { uniqueLink: uniqueLink, needs: [] };
    if (listOfRow?.length) {
        let needArr = listOfRow?.map((item) => {
            return {
                needCategoryIcd10Id: item?.needCategoryIcd10Id,
                needSubCategoryIcd10Id: item?.needSubCategoryIcd10Id,
                needType: item?.needType,
                untagReasonId: item?.untagReasonId,
                goals: item?.goals
            };
        });
        reqBody.needs = needArr;
    }
    return reqBody;
};

export const memberStatusObj = {
    1: 'Invalid Contact Information',
    2: 'Left Voicemail',
    3: 'Member choose DNC',
    4: 'Member completed assessment - needs identified/member refused',
    5: 'Member completed assessment - no needs identified',
    6: 'Member declined to participate in the program',
    7: 'Member/Rep requested for callback',
    8: 'No Answer/CC left a message if able',
    9: 'No longer with Elevance Insurance',
    10: 'Other Insurance',
    11: 'Export Failed : Existing referral in process',
    12: 'Member Exported',
    13: 'Export Failed: Technical Issue'
};

export const getPathAfterDomain = (url) => {
    const urlObject = new URL(url);
    return urlObject.pathname + urlObject.search + urlObject.hash;
};
